import Choices from 'choices.js';

// coverimg responsive 
export const updateCoverImages = () => {
  const coverImages = document.querySelectorAll('.coverimg');
  coverImages.forEach((element) => {
    const img = element.querySelector('img');
    if (img && img.src) {
      (element as HTMLElement).style.backgroundImage = `url('${img.src}')`;
      img.style.display = 'none';
    }
  });
};

// choices
export const updateChoices = () => {
  const instances: Choices[] = [];
  const selects = document.querySelectorAll<HTMLSelectElement>('.choices');

  selects.forEach((el) => {
    if (el.hasAttribute('data-choice')) {
      return;
    }

    if (el && el.tagName === 'SELECT') {
      const instance = new Choices(el, {
        shouldSort: false,
        searchEnabled: false,
        itemSelectText: '',
        classNames: {
          containerOuter: ['maxwidth-dynamic', 'choices'],
        } as any,
      });
      instances.push(instance);
    }
  });

  return () => {
    instances.forEach((inst) => inst.destroy());
  };
}
